export const AT_BOTTOM = 'bottom';

const bottomOf = (items) => items.reduce((max, item) => Math.max(max, item.offsetTop + item.height), 0);

// the position inside the anchored message is a fraction of its height: a wider list
// reflows a long answer to a fraction of its former height, and the reader was a fraction
// of the way through it, not a number of pixels
export const anchorFor = (items, scrollTop, { viewportHeight = 0, scrollHeight = 0 } = {}) => {
  if (items.length === 0) {
    return AT_BOTTOM;
  }
  if (scrollHeight > 0 && scrollTop + viewportHeight >= scrollHeight - 1) {
    return AT_BOTTOM;
  }

  const topmost = items.find((item) => item.offsetTop + item.height > scrollTop) ?? items[items.length - 1];
  const ratio = topmost.height > 0 ? (scrollTop - topmost.offsetTop) / topmost.height : 0;
  return { uid: topmost.uid, ratio };
};

export const offsetFor = (items, anchor) => {
  if (anchor === AT_BOTTOM) {
    return bottomOf(items);
  }

  const anchored = items.find((item) => item.uid === anchor.uid);
  if (anchored === undefined) {
    return bottomOf(items);
  }
  return Math.round(anchored.offsetTop + anchor.ratio * anchored.height);
};
